import React, { useState, useEffect } from "react";
import { isEmpty, isEqual } from "lodash";
import Loader from "components/Loader/index";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ModalPortal from "../../components/ModalPortal";
import MessageModal from "../../components/MessageModal";
import { CSSTransition } from "react-transition-group";
import GridWrapper from "custom-hooks/GridWrapper";
import { setApi, setData } from "reducers/grid";
import { useTranslation } from "react-i18next";
import permissions, { checkPermissions } from "config/permissions";
import { configureFilterObject } from "../../pages/Ordering/common/util/configureFilterObject";
import useDebounce from "../../custom-hooks/useDebounce";
import Diagram from "../../pages/Ordering/common/Diagram";

// const getTabQueryKey = (tabType, id) => `${tabType}_${id}`;


const mapStateToProps = (state, props) => ({
    // currentTabs: state.tabs && state.tabs.tabs,
});

const SearchList = props => {
    const {
        updateApiGrid,
        formValues,
        formErrors,
        query,
        allFilterFields,
        history,
        selectItemPath,
        listInit,
        entity,
        setGridData,
        onGridExport,
        // currentTabs,
    } = props;

    const { t } = useTranslation();

    const { hash } = props.match.params;

    const [modalEventData, setModalEventData] = useState(null);
    const [loadingState, setLoadingState] = useState(false);
    const [prevAppliedFilterObject, setPrevAppliedFilterObject] = useState([]);
    const [prevAppliedQuery, setPrevAppliedQuery] = useState(query);

    const isCanEventsView = checkPermissions(permissions.CalendarOperations.view_calendar_event);

    const { debouncedValue: debouncedFormValues, setDebouncedValue: setDebouncedFormValues } = useDebounce(
        formValues,
        300
    );

    const init = {
        ...listInit,
        extra: hash,
        query,
    };

    const gridKey = `${init.key}_${init.path || init.extra || ""}`;

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    const setOpenMode = mode => {
        if (!isCanEventsView) return;

        setModalEventData(null);
        return history.push(`${modalEventData.url}/${mode}`);
    };

    const getOpenModesForModal = () => {
        if (modalEventData && modalEventData.allowModes) {
            switch (modalEventData.allowModes.length) {
                case 2:
                    return {
                        primaryButton: true,
                        secondaryButton: true,
                        primaryButtonText: modalEventData.allowModes[0].label,
                        onClickPrimaryButton: () => setOpenMode(modalEventData.allowModes[0].code),
                        secondaryButtonText: modalEventData.allowModes[1].label,
                        onClickSecondaryButton: () => setOpenMode(modalEventData.allowModes[1].code),
                    };
                case 3:
                    return {
                        dangerButton: true,
                        primaryButton: true,
                        secondaryButton: true,
                        primaryButtonText: modalEventData.allowModes[0].label,
                        onClickPrimaryButton: () => setOpenMode(modalEventData.allowModes[0].code),
                        secondaryButtonText: modalEventData.allowModes[1].label,
                        onClickSecondaryButton: () => setOpenMode(modalEventData.allowModes[1].code),
                        dangerButtonText: modalEventData.allowModes[2].label,
                        onClickDangerButton: () => setOpenMode(modalEventData.allowModes[2].code),
                    };
            }
        }
    };

    const tryToUpdateApiGrid = (api, gridKey) => {
        if (isEmpty(formErrors)) {
            updateApiGrid(api, gridKey);
        }
    }

    const getParams = () => {
        const params = {
            selectItem: item => {
                if (entity === "clevent") {
                    if (!isCanEventsView) return;

                    if (item.allowModes && item.allowModes.length > 1) {
                        return setModalEventData({
                            url: item.url,
                            allowModes: item.allowModes,
                        });
                    }
                    return history.push(`${item.url}/${item.allowModes[0].code}`);
                }

                if (entity === "task") {
                    // const tabQueryKey = getTabQueryKey('order', item.id);
                    // const existingTab = currentTabs.find(tab => tab.queryKey.startsWith(tabQueryKey));
                    // const urlToPush = existingTab ? existingTab.url : `/order/${item.id}`;
                    // return history.push(urlToPush);
                    return history.push(`/order/${item.id}`);
                }

                if (entity === "spec") {
                    // const tabQueryKey = getTabQueryKey('service', item.id);
                    // const existingTab = currentTabs.find(tab => tab.queryKey.startsWith(tabQueryKey));
                    // const urlToPush = existingTab ? existingTab.url : `/service/${item.id}`;
                    // return history.push(urlToPush);
                    return history.push(`/service/${item.id}`);
                }
                if (entity === "appeal") {
                    // const tabQueryKey = getTabQueryKey('appeals', item.id);
                    // const existingTab = currentTabs.find(tab => tab.queryKey.startsWith(tabQueryKey));
                    // const urlToPush = existingTab ? existingTab.url : `/appeals/${item.id}`;
                    // return history.push(urlToPush);
                    return history.push(`/appeals/${item.id}`);
                }
                if (entity === "contact_person") {
                    return history.push(`/customer/${item.customerId}/person/${item.id}/contact`);
                }
                // const tabQueryKey = getTabQueryKey(selectItemPath, item.id);
                // const existingTab = currentTabs.find(tab => tab.queryKey.startsWith(tabQueryKey));
                // const urlToPush = existingTab ? existingTab.url : `/${selectItemPath}/${item.id}`;

                // return history.push(urlToPush);
                return history.push(`/${selectItemPath}/${item.id}`);
            },
        };
        if (entity === "task") {
            params.fields = {
                hasFlow: { component: Diagram },
            };
        }
        return params;
    };

    useEffect(() => {
        if (debouncedFormValues && allFilterFields && !loadingState) {
            const filterObject = configureFilterObject(debouncedFormValues || {}, allFilterFields) || [];
            setPrevAppliedFilterObject(filterObject);
            setPrevAppliedQuery(query);
            // we need to check if the filter object was changed due to form values changes
            // it is possible that form values are changed via _cached_ajax_options, but we should not trigger grid update in such case
            const isSameFilterObject = isEqual(filterObject, prevAppliedFilterObject);
            // we also need to keep track of query changes and properly trigger an update once query was changed
            const isSameQuery = prevAppliedQuery === query;
            if (!isSameFilterObject || !isSameQuery) {
                tryToUpdateApiGrid({ query, filterObject }, gridKey);
            }
        }
    }, [debouncedFormValues, query]);

    useEffect(() => {
        if (allFilterFields && !loadingState) {
            const filterObject = configureFilterObject(formValues || {}, allFilterFields) || [];
            setPrevAppliedFilterObject(filterObject);
            tryToUpdateApiGrid({ start: 0, query, filterObject }, gridKey);
        }
    }, [hash]);

    useEffect(() => {
        if (!isEmpty(formErrors)) {
            setGridData({ result: [], total: 0, success: true, }, gridKey);
        }
    }, [formErrors]);

    return (
        <>
            <div className="content-wrapper ordering-component-ui-core-wrapper with-fixed-status customer-ordering-grid">
                <div className="content-wrapper">
                    {loadingState && <Loader />}
                    <GridWrapper
                        tuner={() => init}
                        gridParams={getParams()}
                        initUpdate={false}
                        onStart={onStart}
                        onFinish={onFinish}
                        onGridExport={onGridExport}
                        fieldsLsCacheKey={`search_tab_${gridKey}`}
                    />
                </div>
            </div>
            <CSSTransition
                in={modalEventData}
                classNames="fade"
                appear
                enter
                exit
                timeout={300}
                mountOnEnter
                unmountOnExit
            >
                <ModalPortal onClose={() => setModalEventData(null)} className="modal-small modal-center">
                    <MessageModal
                        titleModal={t("calendar.askEventModalTitle")}
                        contentModalText={t("calendar.askEventModalDescription")}
                        {...getOpenModesForModal()}
                    />
                </ModalPortal>
            </CSSTransition>
        </>
    );
};

export default withRouter(connect(mapStateToProps, { updateApiGrid: setApi, setGridData: setData })(SearchList));
